var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import detailsViewActionTypes from "./DetailsViewActionTypes.js";
class DetailsViewActions {
  /**
   * GET /experiments/{id} call Action
   */
  getExperimentData(id) {
    return {
      id,
      type: detailsViewActionTypes.GET_EXP_DATA
    };
  }
  /**
   * GET /experiments/{id} response Action
   */
  parseExperimentData(id, result, error, errorContext) {
    return {
      id,
      type: detailsViewActionTypes.PARSE_EXP_DATA,
      error,
      payload: result,
      errorContext
    };
  }
  /**
   * GET /experiments/{id}/scorecards all scorecards for the experiment
   */
  getExperimentScorecards(id) {
    return {
      id,
      type: detailsViewActionTypes.GET_EXP_SCORECARDS
    };
  }
  parseExperimentScorecards(id, result, error) {
    return {
      id,
      type: detailsViewActionTypes.PARSE_EXP_SCORECARDS,
      payload: result,
      error
    };
  }
  /**
   * GET /experiments/{id}/journal call Action
   */
  getExperimentLog(id) {
    return {
      id,
      type: detailsViewActionTypes.GET_EXP_LOG
    };
  }
  /**
   * GET /experiments/{id}/journal response Action
   */
  parseExperimentLog(id, result, error) {
    return {
      id,
      type: detailsViewActionTypes.PARSE_EXP_LOG,
      error,
      payload: result
    };
  }
  /**
   * GET /experiments/{id}/related call Action
   */
  getExperimentIterations(id) {
    return {
      id,
      type: detailsViewActionTypes.GET_EXP_ITERS
    };
  }
  /**
   * GET /experiments/{id}/related response Action
   */
  parseExperimentIterations(id, result, error) {
    return {
      id,
      type: detailsViewActionTypes.PARSE_EXP_ITERS,
      error,
      payload: result
    };
  }
  /**
   * GET /experiments/{id}/operations call Action
   */
  getOperationsStatus(id) {
    return {
      id,
      type: detailsViewActionTypes.GET_EXP_OPS
    };
  }
  /**
   * GET /experiments/{id}/operations response Action
   */
  parseOperationsStatus(id, result, error) {
    return {
      id,
      type: detailsViewActionTypes.PARSE_EXP_OPS,
      error,
      payload: result
    };
  }
  /**
   * POST /experiments/{id}/start call Action
   */
  initStartExperiment(id, additionalDetails) {
    return {
      id,
      type: detailsViewActionTypes.INIT_START_EXP,
      additionalDetails
    };
  }
  initIterateExperiment(id, additionalDetails) {
    return {
      id,
      type: detailsViewActionTypes.INIT_ITERATE_EXP,
      additionalDetails
    };
  }
  /**
   * Ensuring success or failure of the POST /experiments/{id}/start Action
   */
  finishStartExperiment(id, error) {
    return {
      id,
      type: detailsViewActionTypes.FINISH_START_EXP,
      error,
      payload: null
    };
  }
  /**
   * Ensuring success or failure of the POST /experiments/{id}/clone Action
   */
  finishIteratexperiment(id, iterateId, error) {
    return {
      id,
      type: detailsViewActionTypes.FINISH_ITERATE_EXP,
      error,
      payload: iterateId
    };
  }
  /**
   * GET /experiments/{id}/advance call Action
   */
  getExperimentAdvanceDiff(id) {
    return {
      id,
      type: detailsViewActionTypes.GET_EXP_ADV_DIFF
    };
  }
  /**
   * GET /experiments/{id}/advance response Action
   */
  parseExperimentAdvanceEffect(id, result, error) {
    return {
      id,
      type: detailsViewActionTypes.PARSE_EXP_ADV_EFFECT,
      error,
      payload: result
    };
  }
  /**
   * POST /experiments/{id}/advance call Action
   */
  initAdvanceExperiment(id) {
    return {
      id,
      type: detailsViewActionTypes.INIT_ADVANCE_EXP
    };
  }
  /**
   * Ensuring success or failure of the POST /experiments/{id}/advance Action
   */
  finishAdvanceExperiment(id, error) {
    return {
      id,
      type: detailsViewActionTypes.FINISH_ADVANCE_EXP,
      error,
      payload: null
    };
  }
  /**
   * POST /experiments/{id}/stop call Action
   *
   */
  initStopExperiment(id) {
    return {
      id,
      type: detailsViewActionTypes.INIT_STOP_EXP
    };
  }
  /**
   * Ensuring success or failure of the POST /experiments/{id}/stop Action
   * Ensuring success or failure of the POST /experiments/{id}/emergencystop Action
   */
  finishStopExperiment(id, error) {
    return {
      id,
      type: detailsViewActionTypes.FINISH_STOP_EXP,
      error,
      payload: null
    };
  }
  /**
   * DELETE /experiments/{id} call Action
   */
  initHideExperiment(id) {
    return {
      id,
      type: detailsViewActionTypes.INIT_HIDE_EXP
    };
  }
  /**
   * Ensuring success or failure of the DELETE /experiments/{id} Action
   */
  finishHideExperiment(id, error) {
    return {
      id,
      type: detailsViewActionTypes.FINISH_HIDE_EXP,
      error,
      payload: null
    };
  }
  /**
   * PUT /experiments/{id}?hidden=false call Action
   */
  initUnhideExperiment(id) {
    return {
      id,
      type: detailsViewActionTypes.INIT_UNHIDE_EXP
    };
  }
  /**
   * Ensuring success or failure of the PUT /experiments/{id}?hidden=false Action
   */
  finishUnhideExperiment(id, error) {
    return {
      id,
      type: detailsViewActionTypes.FINISH_UNHIDE_EXP,
      error,
      payload: null
    };
  }
  /**
   * Request to start GET /experiments/{id}/edit call
   */
  loadExperimentEditData(id, workspaceId, managementGroup, isFeatureRollout) {
    return {
      id,
      workspaceId,
      managementGroup,
      // @ts-ignore
      isFeatureRollout,
      type: detailsViewActionTypes.LOAD_EXP_EDIT_DATA
    };
  }
  /**
   * GET /experiments/{id}/edit loading
   */
  loadingExperimentEditData(id) {
    return {
      id,
      type: detailsViewActionTypes.LOADING_EXP_EDIT_DATA
    };
  }
  /**
   * Experiment edit rules are loaded
   */
  loadedExperimentEditData(id, rulesResult, flightControlResult, error, restResult) {
    return __spreadValues({
      id,
      type: detailsViewActionTypes.LOADED_EXP_EDIT_DATA,
      error,
      payload: { editRules: rulesResult, flightControl: flightControlResult }
    }, restResult && restResult.errorContext && { errorContext: restResult.errorContext });
  }
  /**
   * Set experiment edit view Action (open/close)
   */
  setExperimentEditView(id, isOpen) {
    return {
      id,
      type: detailsViewActionTypes.SET_EXP_EDIT_VIEW,
      isEditViewOpen: isOpen
    };
  }
  /**
   * PATCH /experiments/{id} call Action
   */
  initUpdateExperiment(id, update) {
    return {
      id,
      type: detailsViewActionTypes.INIT_UPDATE_EXP_DETAILS,
      update
    };
  }
  /**
   * Ensuring success or failure of the PATCH /experiments/{id} Action
   */
  finishUpdateExperiment(id, error) {
    return {
      id,
      type: detailsViewActionTypes.FINISH_UPDATE_EXP_DETAILS,
      error,
      payload: null
    };
  }
}
const DetailsViewActions$1 = new DetailsViewActions();
export {
  DetailsViewActions,
  DetailsViewActions$1 as default
};
//# sourceMappingURL=DetailsViewActions.js.map
